import { AbstractControl, ValidatorFn } from '@angular/forms';

export function isValidCost(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const cost = parseInt(control.value);
        const price = parseInt(control.parent?.value.price);
        return (cost > price && { invalidCost: true }) || null;
    };
}
